import { type Dayjs } from 'dayjs';

export const CustomerStatus = {
  active: 'Live',
  churned: 'Churned',
} as const;
export type CustomerStatus = (typeof CustomerStatus)[keyof typeof CustomerStatus];

export interface Plan {
  name: string;
}

export class Customer {
  public name: string;
  public status: CustomerStatus;
  public plan: string;
  public firstPayrollRunDate: string;

  constructor(name: string, status: CustomerStatus, plan: string, firstPayrollRunDate: Dayjs) {
    this.name = name;
    this.status = status;
    this.plan = plan;
    this.firstPayrollRunDate = firstPayrollRunDate.isValid()
      ? firstPayrollRunDate.format('MM/DD/YYYY')
      : '-';
  }
}
